import React from "react";
import { LifeBuoy, Mail } from "lucide-react";

const SUPPORT_EMAIL = "support@artadmin.net";

export function NeedHelp({ jobNumber = null, className = "" }) {
  const subject = jobNumber ? `ARPS Support — Job #${jobNumber}` : "ARPS Support Request";
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
  return (
    <div data-testid="need-help" className={`rounded-2xl border border-slate-200 bg-white p-5 sm:p-6 ${className}`}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-emerald-50 text-emerald-600">
          <LifeBuoy className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <h3 className="font-display text-base font-bold text-slate-900">Need help?</h3>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">
            Our team at <span className="font-semibold text-slate-900">Audit Ready Process Service</span> is here to assist.
            {jobNumber
              ? <> If any details on this order are incorrect or you need assistance, email us and reference <span className="font-semibold text-slate-900">Job #{jobNumber}</span>.</>
              : <> If any order details are incorrect or you need assistance, email us and include the relevant <span className="font-semibold text-slate-900">Job Number</span> so we can help quickly.</>}
          </p>

          {jobNumber && (
            <div data-testid="need-help-job-number" className="mt-3 inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm">
              <span className="text-slate-500">Reference</span>
              <span className="font-mono-arps font-semibold text-slate-900">Job #{jobNumber}</span>
            </div>
          )}

          <div className="mt-3">
            <a
              data-testid="need-help-email-link"
              href={mailto}
              className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800 sm:w-auto"
            >
              <Mail className="h-4 w-4" /> Email {SUPPORT_EMAIL}
            </a>
          </div>
          <p className="mt-2 text-xs text-slate-400">Please include your Job Number in your message so we can locate your order quickly.</p>
        </div>
      </div>
    </div>
  );
}
